export const SES_NOTIFICATION_TYPES = {
  cycleInvite: 'ses_cycle_invite',
  cycleReminder: 'ses_cycle_reminder',
} as const;

export type SesNotificationType = (typeof SES_NOTIFICATION_TYPES)[keyof typeof SES_NOTIFICATION_TYPES];
